/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceDto
 */
export interface InvoiceDto {
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDto
     */
    invoiceTotal?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDto
     */
    contractAmount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    invoiceTotalCurrency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof InvoiceDto
     */
    date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    externalOrderId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    orderId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    invoiceNumber?: string | null;
}

/**
 * Check if a given object implements the InvoiceDto interface.
 */
export function instanceOfInvoiceDto(value: object): value is InvoiceDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function InvoiceDtoFromJSON(json: any): InvoiceDto {
    return InvoiceDtoFromJSONTyped(json, false);
}

export function InvoiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'invoiceTotal': json['invoiceTotal'] == null ? undefined : json['invoiceTotal'],
        'contractAmount': json['contractAmount'] == null ? undefined : json['contractAmount'],
        'invoiceTotalCurrency': json['invoiceTotalCurrency'] == null ? undefined : json['invoiceTotalCurrency'],
        'description': json['description'] == null ? undefined : json['description'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'externalOrderId': json['externalOrderId'] == null ? undefined : json['externalOrderId'],
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'invoiceNumber': json['invoiceNumber'] == null ? undefined : json['invoiceNumber'],
    };
}

export function InvoiceDtoToJSON(json: any): InvoiceDto {
    return InvoiceDtoToJSONTyped(json, false);
}

export function InvoiceDtoToJSONTyped(value?: InvoiceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'invoiceTotal': value['invoiceTotal'],
        'contractAmount': value['contractAmount'],
        'invoiceTotalCurrency': value['invoiceTotalCurrency'],
        'description': value['description'],
        'date': value['date'] == null ? value['date'] : value['date'].toISOString(),
        'externalOrderId': value['externalOrderId'],
        'orderId': value['orderId'],
        'invoiceNumber': value['invoiceNumber'],
    };
}

